const categories = [
  {
    title: 'Motor',
    desc: 'Piston, silindir, krank mili, kam mili ve tüm motor bileşenleri',
    img: 'https://readdy.ai/api/search-image?query=heavy%20machinery%20diesel%20engine%20block%20close%20up%20industrial%20mechanical%20components%20bright%20workshop%20background%20clean%20lighting%20warm%20metallic%20orange%20tones%20professional%20photography&width=400&height=300&seq=spw2001&orientation=landscape',
  },
  {
    title: 'Motor Yedek Parçaları',
    desc: 'Conta, segman, supap, yataklama ve motor iç parçaları',
    img: 'https://readdy.ai/api/search-image?query=engine%20spare%20parts%20gaskets%20pistons%20valves%20bearings%20heavy%20equipment%20mechanical%20components%20light%20metallic%20background%20clean%20industrial%20lighting%20warm%20tones%20close%20up%20photography&width=400&height=300&seq=spw2002&orientation=landscape',
  },
  {
    title: 'Şanzıman',
    desc: 'Şanzıman dişlileri, kavrama plakaları ve aktarma organları',
    img: 'https://readdy.ai/api/search-image?query=heavy%20machinery%20gearbox%20transmission%20parts%20gears%20clutch%20plates%20light%20industrial%20background%20metallic%20surfaces%20clean%20lighting%20orange%20accent%20professional%20photography%20close%20up&width=400&height=300&seq=spw2003&orientation=landscape',
  },
  {
    title: 'Diferansiyel',
    desc: 'Diferansiyel dişlileri, aks milleri ve tahrik sistemi parçaları',
    img: 'https://readdy.ai/api/search-image?query=differential%20axle%20gears%20heavy%20equipment%20drivetrain%20components%20light%20industrial%20background%20metallic%20surfaces%20clean%20lighting%20professional%20photography%20close%20up&width=400&height=300&seq=spw2004&orientation=landscape',
  },
  {
    title: 'Hidrolik',
    desc: 'Pompa, motor, silindir, valf ve hidrolik hortum çeşitleri',
    img: 'https://readdy.ai/api/search-image?query=hydraulic%20system%20components%20pumps%20valves%20cylinders%20construction%20machinery%20industrial%20parts%20close%20up%20light%20metallic%20surfaces%20clean%20lighting%20orange%20accent%20professional%20photography&width=400&height=300&seq=spw2005&orientation=landscape',
  },
  {
    title: 'Elektrik Aksamı',
    desc: 'Alternatör, marş motoru, sensör ve elektrik donanımları',
    img: 'https://readdy.ai/api/search-image?query=heavy%20machinery%20electrical%20components%20alternator%20starter%20motor%20sensors%20wiring%20harness%20light%20industrial%20background%20clean%20lighting%20orange%20glow%20professional%20photography&width=400&height=300&seq=spw2006&orientation=landscape',
  },
  {
    title: 'Filtreler',
    desc: 'Yağ, yakıt, hava ve hidrolik filtreler, tüm marka uyumlu',
    img: 'https://readdy.ai/api/search-image?query=industrial%20filters%20oil%20fuel%20air%20hydraulic%20filters%20heavy%20equipment%20light%20background%20clean%20lighting%20metallic%20surfaces%20organized%20display%20industrial%20photography%20warm%20tones%20close%20up&width=400&height=300&seq=spw2007&orientation=landscape',
  },
  {
    title: 'Radyatör',
    desc: 'Su radyatörü, yağ soğutucu ve soğutma sistemi parçaları',
    img: 'https://readdy.ai/api/search-image?query=heavy%20machinery%20radiator%20cooling%20system%20components%20water%20cooler%20oil%20cooler%20industrial%20parts%20light%20metallic%20background%20clean%20lighting%20warm%20tones%20professional%20photography%20close%20up&width=400&height=300&seq=spw2008&orientation=landscape',
  },
  {
    title: 'Jant & Şaft',
    desc: 'Jant, tekerlek göbeği, şaft ve tahrik aksı bileşenleri',
    img: 'https://readdy.ai/api/search-image?query=heavy%20equipment%20wheel%20rim%20hub%20shaft%20drive%20axle%20components%20light%20industrial%20background%20metallic%20surfaces%20clean%20lighting%20professional%20photography%20close%20up%20warm%20tones&width=400&height=300&seq=spw2009&orientation=landscape',
  },
  {
    title: 'PİN',
    desc: 'Bağlantı pimleri, burçlar ve eklem noktası parçaları',
    img: 'https://readdy.ai/api/search-image?query=excavator%20pins%20bushings%20connection%20joints%20heavy%20machinery%20wear%20parts%20light%20industrial%20background%20metallic%20surfaces%20clean%20lighting%20orange%20accent%20professional%20photography%20close%20up&width=400&height=300&seq=spw2010&orientation=landscape',
  },
  {
    title: 'Ataşman',
    desc: 'Kova, kepçe, çekiç ve iş makinası ataşman ekipmanları',
    img: 'https://readdy.ai/api/search-image?query=excavator%20bucket%20attachment%20hammer%20heavy%20machinery%20equipment%20light%20industrial%20background%20clean%20lighting%20earth%20tones%20professional%20photography%20close%20up%20metallic&width=400&height=300&seq=spw2011&orientation=landscape',
  },
  {
    title: 'Kazıcı',
    desc: 'Kazıcı dişleri, adaptörler ve aşınma parçaları',
    img: 'https://readdy.ai/api/search-image?query=excavator%20bucket%20teeth%20adapters%20wear%20parts%20ground%20engaging%20tools%20light%20industrial%20background%20clean%20lighting%20orange%20accent%20professional%20photography%20close%20up%20metallic%20surfaces&width=400&height=300&seq=spw2012&orientation=landscape',
  },
  {
    title: 'Yükleyici',
    desc: 'Yükleyici kepçesi, kolları ve bağlantı elemanları',
    img: 'https://readdy.ai/api/search-image?query=wheel%20loader%20bucket%20arms%20linkage%20heavy%20machinery%20parts%20light%20industrial%20background%20clean%20lighting%20warm%20earth%20tones%20professional%20photography%20close%20up%20metallic&width=400&height=300&seq=spw2013&orientation=landscape',
  },
  {
    title: 'Kabin',
    desc: 'Kabin camı, kapı, koltuk ve operatör kabini parçaları',
    img: 'https://readdy.ai/api/search-image?query=heavy%20machinery%20operator%20cabin%20parts%20glass%20door%20seat%20interior%20components%20light%20industrial%20background%20clean%20lighting%20warm%20tones%20professional%20photography%20close%20up&width=400&height=300&seq=spw2014&orientation=landscape',
  },
];

export default function SpareParts() {
  return (
    <section id="yedek-parca" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-orange-500"></div>
              <span className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase">
                Yedek Parça Çözümleri
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 leading-none">
              İHTİYACINIZ OLAN
              <br />
              HER PARÇA,
              <br />
              <span className="text-orange-500">DOĞRU ZAMANDA.</span>
            </h2>
          </div>
          <p className="text-gray-500 max-w-sm text-sm leading-relaxed">
            Geniş parça yelpazemizle, iş makinanızın her bileşeni için hızlı tedarik sağlıyoruz.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-px bg-gray-200">
          {categories.map((cat, idx) => (
            <div
              key={cat.title}
              className="group relative overflow-hidden cursor-default bg-white"
              style={{ height: '200px' }}
            >
              <img
                src={cat.img}
                alt={cat.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-80"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-white/90 via-white/30 to-transparent"></div>

              {/* Index */}
              <div className="absolute top-2 left-3 text-orange-500/25 font-black text-2xl leading-none select-none">
                {String(idx + 1).padStart(2, '0')}
              </div>

              {/* Active bar */}
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-gray-900 font-black text-xs uppercase tracking-wide leading-tight mb-1">
                  {cat.title}
                </h3>
                <p className="text-gray-500 text-[10px] leading-snug opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-2">
                  {cat.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-px bg-gray-50 border border-gray-200 p-6 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-gray-900 text-xl md:text-2xl font-black mb-1 uppercase">
              Aradığınız Parçayı Bulamadınız mı?
            </h3>
            <p className="text-gray-500 text-sm">
              Uzman ekibimiz, ihtiyacınız olan her parçayı sizin için temin eder.
            </p>
          </div>
          <button
            onClick={() => document.querySelector('#iletisim')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-10 py-4 rounded-sm transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-3 uppercase tracking-widest text-sm"
          >
            <span>Parça Sorgula</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
